import { useComputed } from "@suse-o11y/signal";
import React from "react";

import { useQuery } from "../../../../queries/react-query";
import { useDashboardContext } from "../_dashboard-context";
import { queryMetricLabelValueOptions } from "../_dynamic-variable-query";

import { ListMultiChoiceVariable, type ListMultiChoiceVariableProps } from "./_list-multi-choice";
import { ListSingleChoiceVariable, type ListSingleChoiceVariableProps } from "./_list-single-choice";

type MultiChoiceProps = {
	allowMultiple: true;
} & Omit<ListMultiChoiceVariableProps, "options">;

type SingleChoiceProps = { allowMultiple: false } & Omit<ListSingleChoiceVariableProps, "options">;

type Props = {
	matchers: Array<string>;
	label: string;
} & (MultiChoiceProps | SingleChoiceProps);

export const MetricLabelValues = ({ label, matchers, ...props }: Props) => {
	const { chartTimeRange } = useDashboardContext();
	const [dropdownVisible, setDropdownVisible] = React.useState(false);

	const query = queryMetricLabelValueOptions({
		timeRange: useComputed(chartTimeRange),
		label,
		matchers,
	});

	const { data, error } = useQuery({
		...query,
		keepPreviousData: true,
		enabled: dropdownVisible && query.enabled !== false,
	});

	const options = query.enabled === false || error || data == null ? [] : data.map((value) => ({ value }));

	if (props.allowMultiple) {
		return <ListMultiChoiceVariable {...props} onDropdownVisibleChange={setDropdownVisible} options={options} />;
	}

	return <ListSingleChoiceVariable {...props} onDropdownVisibleChange={setDropdownVisible} options={options} />;
};
